/**
 * Page shown to authenticated users whose accounts are pending admin approval.
 * Provides a clear message and options to log out or visit the public site.
 *
 * Called by:
 * - App.tsx as standalone route at /pending-approval
 */
import { Button, Result, Space } from 'antd';
import { ClockCircleOutlined, LogoutOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

function PendingApprovalPage() {
  const { user, logout, isAuthenticated, isApproved } = useAuth();
  const navigate = useNavigate();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    navigate('/login', { replace: true });
    return null;
  }

  // If already approved, redirect to reviewer portal
  if (isApproved) {
    navigate('/reviewer', { replace: true });
    return null;
  }

  async function handleLogout() {
    await logout();
    navigate('/');
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#0a0a0f',
        padding: '24px',
      }}
    >
      <Result
        icon={<ClockCircleOutlined style={{ color: '#faad14' }} />}
        title={<span style={{ color: '#f5f5f5' }}>Account Pending Approval</span>}
        subTitle={
          <span style={{ color: '#a0a0a0' }}>
            Hi {user?.name || 'there'}, your account has been created but needs to be approved by
            the administrator before you can access the reviewer portal. You'll be able to sign in
            once approved.
          </span>
        }
        extra={
          <Space>
            <Button
              type="primary"
              icon={<HomeOutlined />}
              onClick={() => navigate('/home')}
            >
              Visit Public Site
            </Button>
            <Button
              icon={<LogoutOutlined />}
              onClick={handleLogout}
            >
              Log Out
            </Button>
          </Space>
        }
      />
    </div>
  );
}

export default PendingApprovalPage;
